import React, { useState } from "react"

import { Container, Main, Background } from "./styles"

import Sidebar from "../../components/Sidebar"
import Header from "../../components/Header"
import Alert from "../../components/Alert"

import { useAuth } from "../../hooks/auth"

const Dashboard: React.FC = () => {
  const { expiresSoon, user } = useAuth()

  const [alertOpen, setAlertOpen] = useState(expiresSoon)

  return (
    <Container>
      <Header />

      <Main>
        <Sidebar />

        <Background />
      </Main>

      <Alert
        open={alertOpen}
        message={`A assinatura irá vencer logo (${Intl.DateTimeFormat(
          "pt-BR"
        ).format(
          new Date(user.expiration_date)
        )}). Por favor, providencie a renovação para continuar utilizando o sistema`}
        onClose={() => setAlertOpen(false)}
      />
    </Container>
  )
}

export default Dashboard
